import React from 'react';
import { Link } from 'react-router-dom';
import '../Card/card-style.css';

function CourseCard(props) {
  let {
    id,
    name,
    levels,
    specificcategory,
    limits,
    remainingattempts,
    totalquestions,
    eventdisplay,
    complexity,
    level,
    eventtype,
    category,
    time
  } = props.event;
  return (
    <div className="card text-center shadow">
      <div className="overflow">
        {eventtype !== 'Assignments' ? (
          <h4 className="card-text lavelColsMain">
            Level: <span>{complexity}</span>
          </h4>
        ) : (
          ''
        )}
        {
          <Link to={{ pathname: '/coursequiz', state: props.event }}>
            {eventtype !== 'Assignments' ? (
              <img
                src={props.imgsrc}
                alt=""
                className="card-img-top"
                width="200"
                height="200"
              />
            ) : (
              ''
            )}
            {eventtype == 'Assignments' ? (
              <img
                src={'../assets/' + category + '.png'}
                alt=""
                className="card-img-top"
                width="200"
                height="300"
              />
            ) : (
              ''
            )}
          </Link>
        }
        <div className="card-body text-dark">
          <h4 className="card-text">{name}</h4>
          <h4 className="card-text">Questions: {totalquestions} </h4>
          {eventtype !== 'Assignments' ? (
            <h6 className="card-text">
              Time: {time} seconds
            </h6>
          ) : (
            ''
          )}
          <div className="eventsBtn">
            <Link to={{ pathname: '/coursequiz', state: props.event }}>
              Take Quiz
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseCard;
